const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/route.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
import { fetchAuthSession } from "@/api-queries/auth";
export const Route = createFileRoute("/dashboard/admin")({
  beforeLoad: async () => {
    const session = await fetchAuthSession();
    if (!session?.user) throw redirect({
      to: "/login"
    });
    if (session.user.role !== "admin") throw redirect({
      to: "/dashboard"
    });
    return {
      session
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});